@let input = this.currentMechanicInput();
@let sentence = this.sentence();
@let sentencePart = this.sentencePart();

<div class="level" style="position: relative; width: 100%; height: 100%">
  <div class="background" style="position: absolute; inset: 0; background-color: #a8d5d8; overflow: hidden">
    <img
      [src]="activity().background?.url ?? '/assets/woordkr8/backgrounds/neutral.png'"
      alt=""
      style="object-fit: cover; scale: 1.1; filter: blur(1vh)"
    />
    <app-dust-particles style="position: absolute; inset: 0; filter: blur(0.2vh)" />
  </div>
  @if (sentence && sentencePart) {
    <div
      class="game"
      style="
        position: absolute;
        inset: 0;
        display: grid;
        grid-template-areas: 'panel mechanic';
        grid-template-columns: 2fr 8fr;
        overflow: hidden;
      "
    >
      <div
        #mechanic
        class="mechanic"
        style="grid-area: mechanic; position: relative"
        [style]="{
          'grid-column': isBuildingSentence() ? '1 / 3' : undefined,
        }"
      >
        @if (isBuildingSentence()) {
          <wk8-book-sentence-builder
            [sentence]="sentence"
            [target]="sentencePart"
            style="display: block; position: absolute; inset: 0"
            (finished)="filledVariable()"
            @carousel
          />
        } @else if (input && !fakeLoading()) {
          @switch (input.componentSelector) {
            @case ('wk8-wisselklanken') {
              <div style="position: absolute; inset: 0" @carousel>
                <wk8-wisselklanken
                  [targetWord]="input.arguments.targetWord"
                  [scaleMultiplier]="currentScaleMultiplier()"
                  (finished)="goToNextMechanic()"
                />
              </div>
            }
            @case ('wk8-lees') {
              <div class="grid size-full place-items-center" style="position: absolute; inset: 0" @carousel>
                <!-- <wk8-lezen
                  style="width: 100%; height: 100%; pointer-events: none"
                  (finished)="goToNextMechanic()"
                  [inputOptions]="input.arguments.inputOptions"
                  [scaleMultiplier]="currentScaleMultiplier()"
                ></wk8-lezen> -->
                <wk8-lees [variant]="input.arguments.variant" (finished)="goToNextMechanic()" />
              </div>
            }
            @case ('wk8-sorteren') {
              <wk8-sorteren
                [question]="input.arguments.question"
                [options]="input.arguments.options"
                (finished)="goToNextMechanic()"
                [scaleMultiplier]="currentScaleMultiplier()"
                style="display: block; position: absolute; inset: 0"
                @carousel
              ></wk8-sorteren>
            }
            @case ('wk8-woordpad') {
              <wk8-woordpad
                [path]="input.arguments.path"
                [scaleMultiplier]="currentScaleMultiplier()"
                (finished)="goToNextMechanic()"
                style="display: block; width: 100%; height: 100%"
                @carousel
              ></wk8-woordpad>
            }
          }
        }
      </div>
      @if (_wk8TutorService.isChecking()) {
        <div
          class="overlay"
          [style.backdrop-filter]="
            'brightness(' +
            (_wk8TutorService.shouldHideBackground() ? '0.1' : '0.5') +
            ')' +
            (_wk8TutorService.shouldHideBackground() ? ' blur(4px)' : '')
          "
          style="position: absolute; inset: 0"
          @fade
        ></div>
      }
      @if (_wk8TutorService.isIncorrect()) {
        <div
          class="wrong-overlay"
          style="position: absolute; inset: 0; pointer-events: none; background: radial-gradient(transparent, #f03d30)"
        ></div>
      }
      @if (!isBuildingSentence()) {
        <div class="panel-left" style="grid-area: panel" @slideleft>
          <wk8-tutor-panel [scaleMultiplier]="currentScaleMultiplier()" style="color: #aeafb1" />
        </div>
      }
    </div>
  }
</div>
